import React from 'react';
import { WeekIcon } from 'taboola-ultimate-ui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import SectionHeader from 'modules/campaigns/components/Form/SectionHeader/SectionHeader';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

const ScheduleSectionFrame = ({ isInitiallyCollapsed, children }) => (
    <CommonCollapsibleCard
        id="CAMPAIGN_SCHEDULE"
        header={
            <SectionHeader headerIcon={<WeekIcon />} headerText={<FormattedMessage id="campaign.editor.schedule" />} />
        }
        isInitiallyCollapsed={isInitiallyCollapsed}
    >
        {children}
    </CommonCollapsibleCard>
);

export { ScheduleSectionFrame };
export default ScheduleSectionFrame;
